import { render, staticRenderFns } from "./DesgloseOcupacionComponent.vue?vue&type=template&id=64101542"
import script from "./DesgloseOcupacionComponent.vue?vue&type=script&lang=js"
export * from "./DesgloseOcupacionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports